export enum RetailerOffersViewType {
  ReceivingOffers = 1,
  Archived = 2,
  RequestedOffers = 3
}

(RetailerOffersViewType as any).__typeName = 'RetailerOffersViewType';
